"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityGetResponseDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
class CountryDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CountryDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "India" }),
    tslib_1.__metadata("design:type", String)
], CountryDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], CountryDto.prototype, "isoCode", void 0);
class StateDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 11 }),
    tslib_1.__metadata("design:type", Number)
], StateDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Karnataka" }),
    tslib_1.__metadata("design:type", String)
], StateDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "KA" }),
    tslib_1.__metadata("design:type", String)
], StateDto.prototype, "stateCode", void 0);
class CityDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 23 }),
    tslib_1.__metadata("design:type", Number)
], CityDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Bengaluru" }),
    tslib_1.__metadata("design:type", String)
], CityDto.prototype, "name", void 0);
class AddressDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1001 }),
    tslib_1.__metadata("design:type", Number)
], AddressDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Nope" }),
    tslib_1.__metadata("design:type", String)
], AddressDto.prototype, "address1", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Nope" }),
    tslib_1.__metadata("design:type", String)
], AddressDto.prototype, "address2", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CityDto }),
    tslib_1.__metadata("design:type", CityDto)
], AddressDto.prototype, "city", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: StateDto }),
    tslib_1.__metadata("design:type", StateDto)
], AddressDto.prototype, "state", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CountryDto }),
    tslib_1.__metadata("design:type", CountryDto)
], AddressDto.prototype, "country", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "999999" }),
    tslib_1.__metadata("design:type", String)
], AddressDto.prototype, "pinCode", void 0);
class RiskLocationDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 231 }),
    tslib_1.__metadata("design:type", Number)
], RiskLocationDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 247 }),
    tslib_1.__metadata("design:type", Number)
], RiskLocationDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1001 }),
    tslib_1.__metadata("design:type", Number)
], RiskLocationDto.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: AddressDto }),
    tslib_1.__metadata("design:type", AddressDto)
], RiskLocationDto.prototype, "address", void 0);
class DocumentDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 141 }),
    tslib_1.__metadata("design:type", Number)
], DocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 247 }),
    tslib_1.__metadata("design:type", Number)
], DocumentDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 102 }),
    tslib_1.__metadata("design:type", Number)
], DocumentDto.prototype, "documentId", void 0);
class ClaimExperienceDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 190 }),
    tslib_1.__metadata("design:type", Number)
], ClaimExperienceDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 247 }),
    tslib_1.__metadata("design:type", Number)
], ClaimExperienceDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2023-01-01" }),
    tslib_1.__metadata("design:type", String)
], ClaimExperienceDto.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2023-12-31" }),
    tslib_1.__metadata("design:type", String)
], ClaimExperienceDto.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Fire" }),
    tslib_1.__metadata("design:type", String)
], ClaimExperienceDto.prototype, "natureOfLoss", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000 }),
    tslib_1.__metadata("design:type", Number)
], ClaimExperienceDto.prototype, "premium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 5000 }),
    tslib_1.__metadata("design:type", Number)
], ClaimExperienceDto.prototype, "claimAmount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 20 }),
    tslib_1.__metadata("design:type", Number)
], ClaimExperienceDto.prototype, "claimPercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "No major issues" }),
    tslib_1.__metadata("design:type", String)
], ClaimExperienceDto.prototype, "remarks", void 0);
class MediatorCompanyDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 434 }),
    tslib_1.__metadata("design:type", Number)
], MediatorCompanyDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "IT solutions" }),
    tslib_1.__metadata("design:type", String)
], MediatorCompanyDto.prototype, "companyName", void 0);
class MediatorDetailsDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 83 }),
    tslib_1.__metadata("design:type", Number)
], MediatorDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 247 }),
    tslib_1.__metadata("design:type", Number)
], MediatorDetailsDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: MediatorCompanyDto, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], MediatorDetailsDto.prototype, "company", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], MediatorDetailsDto.prototype, "location", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], MediatorDetailsDto.prototype, "branch", void 0);
class PlacementDetailsDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 180 }),
    tslib_1.__metadata("design:type", Number)
], PlacementDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 247 }),
    tslib_1.__metadata("design:type", Number)
], PlacementDetailsDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "High competition mitigated by offering better pricing.",
    }),
    tslib_1.__metadata("design:type", String)
], PlacementDetailsDto.prototype, "challengesAndMitigation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Competitor A and Competitor B are active in this region.",
    }),
    tslib_1.__metadata("design:type", String)
], PlacementDetailsDto.prototype, "existingCompetition", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Client prefers a long-term policy." }),
    tslib_1.__metadata("design:type", String)
], PlacementDetailsDto.prototype, "remarks", void 0);
class CommunicationDetailsDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 397 }),
    tslib_1.__metadata("design:type", Number)
], CommunicationDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "email" }),
    tslib_1.__metadata("design:type", String)
], CommunicationDetailsDto.prototype, "communicationType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "mannam12340987@gmail.com" }),
    tslib_1.__metadata("design:type", String)
], CommunicationDetailsDto.prototype, "communicationDetails", void 0);
class ContactDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 268 }),
    tslib_1.__metadata("design:type", Number)
], ContactDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Mannam dept Lakshmi Narayana test" }),
    tslib_1.__metadata("design:type", String)
], ContactDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [CommunicationDetailsDto] }),
    tslib_1.__metadata("design:type", Array)
], ContactDto.prototype, "communicationDetails", void 0);
class OpportunityContactDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 71 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityContactDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: ContactDto }),
    tslib_1.__metadata("design:type", ContactDto)
], OpportunityContactDto.prototype, "contact", void 0);
class CompanyDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 434 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "IT solutions" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CountryDto }),
    tslib_1.__metadata("design:type", CountryDto)
], CompanyDto.prototype, "country", void 0);
class LookupDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 255 }),
    tslib_1.__metadata("design:type", Number)
], LookupDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Fire" }),
    tslib_1.__metadata("design:type", String)
], LookupDto.prototype, "lookUpValue", void 0);
class OpportunityDataDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 247 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "estimatedBrokerage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-12-31" }),
    tslib_1.__metadata("design:type", String)
], OpportunityDataDto.prototype, "soExpireDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 500000 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 20000 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "premiumPaid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 500 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "estimatedFee", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Some source" }),
    tslib_1.__metadata("design:type", String)
], OpportunityDataDto.prototype, "source", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Some salesPitch" }),
    tslib_1.__metadata("design:type", String)
], OpportunityDataDto.prototype, "salesPitch", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CompanyDto }),
    tslib_1.__metadata("design:type", CompanyDto)
], OpportunityDataDto.prototype, "company", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: LookupDto }),
    tslib_1.__metadata("design:type", LookupDto)
], OpportunityDataDto.prototype, "policyType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: LookupDto }),
    tslib_1.__metadata("design:type", LookupDto)
], OpportunityDataDto.prototype, "policyStatus", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: LookupDto }),
    tslib_1.__metadata("design:type", LookupDto)
], OpportunityDataDto.prototype, "serviceLevel", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: LookupDto }),
    tslib_1.__metadata("design:type", LookupDto)
], OpportunityDataDto.prototype, "opportunityType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: LookupDto }),
    tslib_1.__metadata("design:type", LookupDto)
], OpportunityDataDto.prototype, "opportunitySource", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: LookupDto }),
    tslib_1.__metadata("design:type", LookupDto)
], OpportunityDataDto.prototype, "isPolicyMined", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [RiskLocationDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "riskLocations", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [DocumentDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [ClaimExperienceDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "claimExperiences", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [MediatorDetailsDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "previousMediatorDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [PlacementDetailsDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "previousPlacementDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [OpportunityContactDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "contacts", void 0);
class OpportunityGetResponseDto {
}
exports.OpportunityGetResponseDto = OpportunityGetResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 201 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityGetResponseDto.prototype, "status", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Opportunity created successfully" }),
    tslib_1.__metadata("design:type", String)
], OpportunityGetResponseDto.prototype, "message", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: OpportunityDataDto }),
    tslib_1.__metadata("design:type", OpportunityDataDto)
], OpportunityGetResponseDto.prototype, "data", void 0);
